import { rewardAmount } from "./rewardAmount";

/**
 * noshAPIから実績一覧を取得する
 * @param {*} userId 
 * @returns 
 */
const fetchRewards = async (userId) => {
  try {
    const baseURL = "https://nosh.jp/api/amb";
    const query = `ambassador_id=${userId}`;
    const url = `${baseURL}/reward?${query}`;
    const result = await fetch(url);
    const data = await result.json();
    const rewards = data.map((item) => {
      const createdAt = new Date(item.created_at);
      const amount = rewardAmount(createdAt);
      return {
        id: item.id,
        amount: amount,
        createdAt: item.created_at,
        judgeStatus: item.judge_status,
        transferredAt: item.transferred_at,
      };
    });
    return rewards;
  } catch (e) {
    console.log(e);
  }
};

export default fetchRewards;
